@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_882_276_808)
internal val Res.string.exp_content_la_particella_ni_14: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_14", "exp_content_la_particella_ni_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 73608, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73124, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 75212, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70404, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68272, 71),
      ))
    }

@delegate:ResourceContentHash(-594_346_089)
internal val Res.string.exp_content_la_particella_ni_2: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_2", "exp_content_la_particella_ni_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 73755, 134),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73279, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 75355, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70551, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68411, 102),
      ))
    }

@delegate:ResourceContentHash(1_757_663_165)
internal val Res.string.exp_content_la_particella_ni_3: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_3", "exp_content_la_particella_ni_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 73890, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73382, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 75462, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70658, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68514, 70),
      ))
    }

@delegate:ResourceContentHash(-1_854_770_418)
internal val Res.string.exp_content_la_particella_ni_4: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_4", "exp_content_la_particella_ni_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 73969, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73457, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 75541, 126),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70729, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68585, 106),
      ))
    }

@delegate:ResourceContentHash(-321_897_371)
internal val Res.string.exp_content_la_particella_ni_5: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_5", "exp_content_la_particella_ni_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 74088, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73568, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 75668, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70836, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68692, 90),
      ))
    }

@delegate:ResourceContentHash(-1_207_748_846)
internal val Res.string.exp_content_la_particella_ni_6: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_6", "exp_content_la_particella_ni_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 74195, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73663, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 75767, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70931, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68783, 106),
      ))
    }

@delegate:ResourceContentHash(1_519_374_543)
internal val Res.string.exp_content_la_particella_ni_7: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_7", "exp_content_la_particella_ni_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 74326, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73770, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 75886, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71034, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68890, 98),
      ))
    }

@delegate:ResourceContentHash(762_825_048)
internal val Res.string.exp_content_la_particella_ni_8: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_8", "exp_content_la_particella_ni_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 74441, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73873, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76005, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71133, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68989, 90),
      ))
    }

@delegate:ResourceContentHash(-511_223_822)
internal val Res.string.exp_content_la_particella_ni_9: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_9", "exp_content_la_particella_ni_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 74512, 190),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73956, 194),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76096, 218),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71212, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69080, 186),
      ))
    }

@delegate:ResourceContentHash(-1_527_807_419)
internal val Res.string.exp_content_la_pazienza_e_finita_1: StringResource by lazy {
      StringResource("string:exp_content_la_pazienza_e_finita_1", "exp_content_la_pazienza_e_finita_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 74703, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74151, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76315, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71399, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69267, 106),
      ))
    }

@delegate:ResourceContentHash(-1_128_653_890)
internal val Res.string.exp_content_la_pazienza_e_finita_2: StringResource by lazy {
      StringResource("string:exp_content_la_pazienza_e_finita_2", "exp_content_la_pazienza_e_finita_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 74826, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74266, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76434, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71510, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69374, 110),
      ))
    }

@delegate:ResourceContentHash(-1_137_475_218)
internal val Res.string.exp_content_la_pazienza_e_finita_3: StringResource by lazy {
      StringResource("string:exp_content_la_pazienza_e_finita_3", "exp_content_la_pazienza_e_finita_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 74937, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74385, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76565, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71621, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69485, 102),
      ))
    }

@delegate:ResourceContentHash(-2_066_408_689)
internal val Res.string.exp_content_la_pazienza_e_finita_4: StringResource by lazy {
      StringResource("string:exp_content_la_pazienza_e_finita_4", "exp_content_la_pazienza_e_finita_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 75048, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74492, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76696, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71720, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69588, 94),
      ))
    }

@delegate:ResourceContentHash(-1_824_752_667)
internal val Res.string.exp_content_la_pazienza_e_finita_5: StringResource by lazy {
      StringResource("string:exp_content_la_pazienza_e_finita_5", "exp_content_la_pazienza_e_finita_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 75135, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74587, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76783, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71807, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69683, 86),
      ))
    }

@delegate:ResourceContentHash(632_309_696)
internal val Res.string.exp_content_la_pazienza_e_finita_6: StringResource by lazy {
      StringResource("string:exp_content_la_pazienza_e_finita_6", "exp_content_la_pazienza_e_finita_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 75218, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74662, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76862, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71886, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69770, 98),
      ))
    }

@delegate:ResourceContentHash(-1_999_977_231)
internal val Res.string.exp_content_la_pazienza_e_finita_7: StringResource by lazy {
      StringResource("string:exp_content_la_pazienza_e_finita_7", "exp_content_la_pazienza_e_finita_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 75317, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74761, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 76961, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 71973, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69869, 98),
      ))
    }

@delegate:ResourceContentHash(963_283_453)
internal val Res.string.exp_content_la_pazienza_e_finita_8: StringResource by lazy {
      StringResource("string:exp_content_la_pazienza_e_finita_8", "exp_content_la_pazienza_e_finita_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 75424, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74868, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 77080, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 72080, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69968, 58),
      ))
    }

@delegate:ResourceContentHash(1_962_042_094)
internal val Res.string.exp_content_la_struttura_semplice_n_n_nome_1_nome_2_nome_: StringResource by
    lazy {
      StringResource("string:exp_content_la_struttura_semplice_n_n_nome_1_nome_2_nome_", "exp_content_la_struttura_semplice_n_n_nome_1_nome_2_nome_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 75483, 197),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 74927, 197),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 77143, 197),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 72139, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70027, 189),
      ))
    }

@delegate:ResourceContentHash(610_894_757)
internal val Res.string.exp_content_la_struttura_semplicissima_n_n_nome_posseduto: StringResource by
    lazy {
      StringResource("string:exp_content_la_struttura_semplicissima_n_n_nome_posseduto", "exp_content_la_struttura_semplicissima_n_n_nome_posseduto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 75681, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 75125, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 77341, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 72337, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70217, 145),
      ))
    }

@delegate:ResourceContentHash(-1_908_187_759)
internal val Res.string.exp_content_la_teoria_1: StringResource by lazy {
      StringResource("string:exp_content_la_teoria_1", "exp_content_la_teoria_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 75839, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 75283, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 77503, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 72495, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70363, 71),
      ))
    }

@delegate:ResourceContentHash(-988_860_464)
internal val Res.string.exp_content_la_teoria_2: StringResource by lazy {
      StringResource("string:exp_content_la_teoria_2", "exp_content_la_teoria_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 75923, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 75359, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 77595, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 72571, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70435, 95),
      ))
    }

@delegate:ResourceContentHash(-379_439_318)
internal val Res.string.exp_content_la_teoria_3: StringResource by lazy {
      StringResource("string:exp_content_la_teoria_3", "exp_content_la_teoria_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76023, 199),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 75451, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 77679, 155),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 72663, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70531, 159),
      ))
    }

@delegate:ResourceContentHash(1_264_362_578)
internal val Res.string.exp_content_la_teoria_4: StringResource by lazy {
      StringResource("string:exp_content_la_teoria_4", "exp_content_la_teoria_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76223, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 75607, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 77835, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 72827, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70691, 59),
      ))
    }

@delegate:ResourceContentHash(-245_249_327)
internal val Res.string.exp_content_la_teoria_5: StringResource by lazy {
      StringResource("string:exp_content_la_teoria_5", "exp_content_la_teoria_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76299, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 75695, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 77919, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 72903, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70751, 99),
      ))
    }

@delegate:ResourceContentHash(-174_149_485)
internal val Res.string.exp_content_la_teoria_6: StringResource by lazy {
      StringResource("string:exp_content_la_teoria_6", "exp_content_la_teoria_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76399, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 75795, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78015, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 72991, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70851, 87),
      ))
    }

@delegate:ResourceContentHash(-1_339_727_749)
internal val Res.string.exp_content_la_teoria_7: StringResource by lazy {
      StringResource("string:exp_content_la_teoria_7", "exp_content_la_teoria_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76527, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 75891, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78135, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73083, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70939, 91),
      ))
    }

@delegate:ResourceContentHash(783_646_224)
internal val Res.string.exp_content_le_due_sorelle_snty: StringResource by lazy {
      StringResource("string:exp_content_le_due_sorelle_snty", "exp_content_le_due_sorelle_snty", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76635, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 75987, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78235, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73175, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71031, 75),
      ))
    }

@delegate:ResourceContentHash(940_147_987)
internal val Res.string.exp_content_le_frasi_avverbiali_1: StringResource by lazy {
      StringResource("string:exp_content_le_frasi_avverbiali_1", "exp_content_le_frasi_avverbiali_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76719, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76063, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78315, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73247, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71107, 105),
      ))
    }

@delegate:ResourceContentHash(-1_898_540_412)
internal val Res.string.exp_content_le_frasi_avverbiali_2: StringResource by lazy {
      StringResource("string:exp_content_le_frasi_avverbiali_2", "exp_content_le_frasi_avverbiali_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76837, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76177, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78433, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73357, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71213, 69),
      ))
    }

@delegate:ResourceContentHash(-97_673_975)
internal val Res.string.exp_content_le_frasi_avverbiali_3: StringResource by lazy {
      StringResource("string:exp_content_le_frasi_avverbiali_3", "exp_content_le_frasi_avverbiali_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76903, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76255, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78511, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73427, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71283, 85),
      ))
    }

@delegate:ResourceContentHash(-675_827_229)
internal val Res.string.exp_content_le_frasi_avverbiali_4: StringResource by lazy {
      StringResource("string:exp_content_le_frasi_avverbiali_4", "exp_content_le_frasi_avverbiali_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 76993, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76341, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78597, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73505, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71369, 113),
      ))
    }

@delegate:ResourceContentHash(-1_346_362_240)
internal val Res.string.exp_content_le_frasi_avverbiali_5: StringResource by lazy {
      StringResource("string:exp_content_le_frasi_avverbiali_5", "exp_content_le_frasi_avverbiali_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77123, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76463, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78723, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73627, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71483, 81),
      ))
    }

@delegate:ResourceContentHash(764_820_056)
internal val Res.string.exp_content_le_preposizioni_1: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_1", "exp_content_le_preposizioni_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 78163, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 77475, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79767, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 74611, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72471, 141),
      ))
    }

@delegate:ResourceContentHash(-262_645_943)
internal val Res.string.exp_content_le_preposizioni_10: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_10", "exp_content_le_preposizioni_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77209, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76549, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78805, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73713, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71565, 50),
      ))
    }

@delegate:ResourceContentHash(-255_367_587)
internal val Res.string.exp_content_le_preposizioni_11: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_11", "exp_content_le_preposizioni_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77256, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76600, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78860, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73764, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71616, 66),
      ))
    }

@delegate:ResourceContentHash(645_779_000)
internal val Res.string.exp_content_le_preposizioni_12: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_12", "exp_content_le_preposizioni_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77323, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76667, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 78923, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73827, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71683, 122),
      ))
    }

@delegate:ResourceContentHash(-3_718_498)
internal val Res.string.exp_content_le_preposizioni_13: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_13", "exp_content_le_preposizioni_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77450, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76794, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79042, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 73946, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71806, 122),
      ))
    }

@delegate:ResourceContentHash(-1_761_388_298)
internal val Res.string.exp_content_le_preposizioni_14: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_14", "exp_content_le_preposizioni_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77577, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 76933, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79173, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 74065, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71929, 106),
      ))
    }

@delegate:ResourceContentHash(723_049_620)
internal val Res.string.exp_content_le_preposizioni_15: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_15", "exp_content_le_preposizioni_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77700, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 77048, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79296, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 74176, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72036, 50),
      ))
    }

@delegate:ResourceContentHash(-781_039_057)
internal val Res.string.exp_content_le_preposizioni_16: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_16", "exp_content_le_preposizioni_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77747, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 77099, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79347, 162),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 74227, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72087, 134),
      ))
    }

@delegate:ResourceContentHash(1_460_471_237)
internal val Res.string.exp_content_le_preposizioni_17: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_17", "exp_content_le_preposizioni_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77894, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 77230, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79510, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 74366, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72222, 58),
      ))
    }

@delegate:ResourceContentHash(1_142_852_056)
internal val Res.string.exp_content_le_preposizioni_18: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_18", "exp_content_le_preposizioni_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 77949, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 77285, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79569, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 74425, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72281, 50),
      ))
    }

@delegate:ResourceContentHash(-241_039_724)
internal val Res.string.exp_content_le_preposizioni_19: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_19", "exp_content_le_preposizioni_19", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 78000, 162),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 77336, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79620, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 74476, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72332, 138),
      ))
    }

@delegate:ResourceContentHash(-27_709_243)
internal val Res.string.exp_content_le_preposizioni_2: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_2", "exp_content_le_preposizioni_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 78713, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78061, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80321, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75181, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73001, 109),
      ))
    }

@delegate:ResourceContentHash(130_678_068)
internal val Res.string.exp_content_le_preposizioni_20: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_20", "exp_content_le_preposizioni_20", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 78313, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 77633, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 79921, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 74761, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72613, 134),
      ))
    }

@delegate:ResourceContentHash(1_909_578_093)
internal val Res.string.exp_content_le_preposizioni_21: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_21", "exp_content_le_preposizioni_21", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 78436, 134),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 77776, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80060, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 74900, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72748, 118),
      ))
    }

@delegate:ResourceContentHash(1_518_920_031)
internal val Res.string.exp_content_le_preposizioni_22: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_22", "exp_content_le_preposizioni_22", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 78571, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 77919, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80179, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75039, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72867, 86),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_le_preposizioni_23: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_23", "exp_content_le_preposizioni_23", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 78666, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78010, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80270, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75134, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72954, 46),
      ))
    }

@delegate:ResourceContentHash(-1_119_182_772)
internal val Res.string.exp_content_le_preposizioni_3: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_3", "exp_content_le_preposizioni_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 78831, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78163, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80435, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75283, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73111, 57),
      ))
    }

@delegate:ResourceContentHash(1_774_770_551)
internal val Res.string.exp_content_le_preposizioni_4: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_4", "exp_content_le_preposizioni_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 78901, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78229, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80509, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75341, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73169, 145),
      ))
    }

@delegate:ResourceContentHash(-887_670_044)
internal val Res.string.exp_content_le_preposizioni_5: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_5", "exp_content_le_preposizioni_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79067, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78387, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80687, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75499, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73315, 89),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_le_preposizioni_6: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_6", "exp_content_le_preposizioni_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79165, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78485, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80781, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75593, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73405, 45),
      ))
    }

@delegate:ResourceContentHash(-412_474_438)
internal val Res.string.exp_content_le_preposizioni_7: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_7", "exp_content_le_preposizioni_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79211, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78535, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80831, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75639, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73451, 61),
      ))
    }

@delegate:ResourceContentHash(177_371_879)
internal val Res.string.exp_content_le_preposizioni_8: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_8", "exp_content_le_preposizioni_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79269, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78597, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80893, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75693, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73513, 61),
      ))
    }

@delegate:ResourceContentHash(-274_280_446)
internal val Res.string.exp_content_le_preposizioni_9: StringResource by lazy {
      StringResource("string:exp_content_le_preposizioni_9", "exp_content_le_preposizioni_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79339, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78667, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 80963, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75767, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73575, 65),
      ))
    }

@delegate:ResourceContentHash(-332_706_309)
internal val Res.string.exp_content_lezione_finita: StringResource by lazy {
      StringResource("string:exp_content_lezione_finita", "exp_content_lezione_finita", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79549, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78905, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 81185, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75981, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73789, 58),
      ))
    }

@delegate:ResourceContentHash(1_299_727_532)
internal val Res.string.exp_content_lezione_finita_cartigli: StringResource by lazy {
      StringResource("string:exp_content_lezione_finita_cartigli", "exp_content_lezione_finita_cartigli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79401, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78741, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 81029, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75833, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73641, 67),
      ))
    }

@delegate:ResourceContentHash(1_341_524_348)
internal val Res.string.exp_content_lezione_finita_genitivo_indiretto_i: StringResource by lazy {
      StringResource("string:exp_content_lezione_finita_genitivo_indiretto_i", "exp_content_lezione_finita_genitivo_indiretto_i", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79469, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78817, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 81101, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 75901, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73709, 79),
      ))
    }

@delegate:ResourceContentHash(-2_107_085_338)
internal val Res.string.exp_content_ma_come_faccio_a_capire_se_due_nomi_in_fila_s: StringResource by
    lazy {
      StringResource("string:exp_content_ma_come_faccio_a_capire_se_due_nomi_in_fila_s", "exp_content_ma_come_faccio_a_capire_se_due_nomi_in_fila_s", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79608, 213),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 78968, 189),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 81244, 181),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 76036, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73848, 173),
      ))
    }

@delegate:ResourceContentHash(795_782_480)
internal val Res.string.exp_content_ma_cosa_succede_se_accostiamo_vino_e_birra_n_: StringResource by
    lazy {
      StringResource("string:exp_content_ma_cosa_succede_se_accostiamo_vino_e_birra_n_", "exp_content_ma_cosa_succede_se_accostiamo_vino_e_birra_n_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 79822, 217),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 79158, 201),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 81426, 229),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 76210, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74022, 197),
      ))
    }

@delegate:ResourceContentHash(-1_023_736_086)
internal val Res.string.exp_content_ma_prima: StringResource by lazy {
      StringResource("string:exp_content_ma_prima", "exp_content_ma_prima", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 80254, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 79550, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 81846, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 76590, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74406, 44),
      ))
    }

@delegate:ResourceContentHash(-889_733_722)
internal val Res.string.exp_content_ma_prima_di_procedere_mettiti_alla_prova_con_: StringResource by
    lazy {
      StringResource("string:exp_content_ma_prima_di_procedere_mettiti_alla_prova_con_", "exp_content_ma_prima_di_procedere_mettiti_alla_prova_con_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 80040, 213),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 79360, 189),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 81656, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 76396, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74220, 185),
      ))
    }

@delegate:ResourceContentHash(2_019_737_161)
internal val Res.string.exp_content_ma_se_una_scritta_composta_solo_da_segni_simm: StringResource by
    lazy {
      StringResource("string:exp_content_ma_se_una_scritta_composta_solo_da_segni_simm", "exp_content_ma_se_una_scritta_composta_solo_da_segni_simm", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 80303, 249),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 79599, 209),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 81895, 233),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 76635, 213),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74451, 213),
      ))
    }

@delegate:ResourceContentHash(1_404_352_396)
internal val Res.string.exp_content_mi_ti_srw_1: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_1", "exp_content_mi_ti_srw_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81018, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80254, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82610, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77258, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75110, 79),
      ))
    }

@delegate:ResourceContentHash(602_038_720)
internal val Res.string.exp_content_mi_ti_srw_10: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_10", "exp_content_mi_ti_srw_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 80553, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 79809, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82129, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 76849, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74665, 92),
      ))
    }

@delegate:ResourceContentHash(961_202_405)
internal val Res.string.exp_content_mi_ti_srw_11: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_11", "exp_content_mi_ti_srw_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 80658, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 79902, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82238, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 76938, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74758, 104),
      ))
    }

@delegate:ResourceContentHash(-197_926_261)
internal val Res.string.exp_content_mi_ti_srw_12: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_12", "exp_content_mi_ti_srw_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 80767, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80003, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82343, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77027, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74863, 88),
      ))
    }

@delegate:ResourceContentHash(-186_290_070)
internal val Res.string.exp_content_mi_ti_srw_13: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_13", "exp_content_mi_ti_srw_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 80876, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80104, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82452, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77116, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74952, 64),
      ))
    }

@delegate:ResourceContentHash(-308_977_916)
internal val Res.string.exp_content_mi_ti_srw_14: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_14", "exp_content_mi_ti_srw_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 80941, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80177, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82525, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77181, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75017, 92),
      ))
    }

@delegate:ResourceContentHash(980_717_814)
internal val Res.string.exp_content_mi_ti_srw_2: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_2", "exp_content_mi_ti_srw_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81102, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80346, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82690, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77338, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75190, 79),
      ))
    }

@delegate:ResourceContentHash(-839_202_668)
internal val Res.string.exp_content_mi_ti_srw_3: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_3", "exp_content_mi_ti_srw_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81170, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80414, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82758, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77402, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75270, 59),
      ))
    }

@delegate:ResourceContentHash(-1_611_903_675)
internal val Res.string.exp_content_mi_ti_srw_4: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_4", "exp_content_mi_ti_srw_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81234, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80474, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82818, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77458, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75330, 63),
      ))
    }

@delegate:ResourceContentHash(-604_502_683)
internal val Res.string.exp_content_mi_ti_srw_5: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_5", "exp_content_mi_ti_srw_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81294, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80542, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 82890, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77522, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75394, 115),
      ))
    }

@delegate:ResourceContentHash(-451_229_158)
internal val Res.string.exp_content_mi_ti_srw_6: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_6", "exp_content_mi_ti_srw_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81418, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80654, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 83010, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77638, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75510, 91),
      ))
    }

@delegate:ResourceContentHash(1_128_663_075)
internal val Res.string.exp_content_mi_ti_srw_7: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_7", "exp_content_mi_ti_srw_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81518, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80750, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 83110, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77726, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75602, 71),
      ))
    }

@delegate:ResourceContentHash(1_528_146_138)
internal val Res.string.exp_content_mi_ti_srw_8: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_8", "exp_content_mi_ti_srw_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81598, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80842, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 83186, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77802, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75674, 47),
      ))
    }

@delegate:ResourceContentHash(1_705_844_145)
internal val Res.string.exp_content_mi_ti_srw_9: StringResource by lazy {
      StringResource("string:exp_content_mi_ti_srw_9", "exp_content_mi_ti_srw_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81646, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 80894, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 83238, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77854, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75722, 111),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_miao: StringResource by lazy {
      StringResource("string:exp_content_miao", "exp_content_miao", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81770, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 81006, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 83350, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77966, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75834, 32),
      ))
    }

@delegate:ResourceContentHash(-863_961_414)
internal val Res.string.exp_content_mysterious_cartouche_intro: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_intro", "exp_content_mysterious_cartouche_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81803, 134),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 81043, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 83387, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 77999, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75867, 118),
      ))
    }

@delegate:ResourceContentHash(377_495_216)
internal val Res.string.exp_content_mysterious_cartouche_known_title: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_known_title", "exp_content_mysterious_cartouche_known_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 81938, 196),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 81158, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 83522, 180),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 78118, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75986, 172),
      ))
    }

@delegate:ResourceContentHash(1_927_668_894)
internal val Res.string.exp_content_mysterious_cartouche_known_words: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_known_words", "exp_content_mysterious_cartouche_known_words", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 82135, 164),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 81327, 144),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 83703, 172),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 78295, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76159, 144),
      ))
    }

@delegate:ResourceContentHash(-1_635_269_256)
internal val Res.string.exp_content_mysterious_cartouche_missing_word: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_missing_word", "exp_content_mysterious_cartouche_missing_word", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 82300, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 81472, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 83876, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 78444, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76304, 141),
      ))
    }

@delegate:ResourceContentHash(1_100_726_021)
internal val Res.string.exp_content_mysterious_cartouche_reveal_1: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_reveal_1", "exp_content_mysterious_cartouche_reveal_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 82442, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 81626, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 84026, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 78598, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76446, 125),
      ))
    }

@delegate:ResourceContentHash(-131_284_478)
internal val Res.string.exp_content_mysterious_cartouche_reveal_2: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_reveal_2", "exp_content_mysterious_cartouche_reveal_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 82580, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 81776, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 84172, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 78740, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76572, 101),
      ))
    }

@delegate:ResourceContentHash(-296_501_632)
internal val Res.string.exp_content_mysterious_cartouche_reveal_3: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_reveal_3", "exp_content_mysterious_cartouche_reveal_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 82686, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 81886, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 84278, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 78854, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76674, 113),
      ))
    }

@delegate:ResourceContentHash(372_076_483)
internal val Res.string.exp_content_mysterious_cartouche_reveal_4: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_reveal_4", "exp_content_mysterious_cartouche_reveal_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 82812, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 82004, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 84400, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 78972, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76788, 125),
      ))
    }

@delegate:ResourceContentHash(-1_236_914_950)
internal val Res.string.exp_content_mysterious_cartouche_reveal_5: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_reveal_5", "exp_content_mysterious_cartouche_reveal_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 82934, 185),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 82142, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 84538, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 79102, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76914, 161),
      ))
    }

@delegate:ResourceContentHash(2_016_130_120)
internal val Res.string.exp_content_mysterious_cartouche_reveal_6: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_reveal_6", "exp_content_mysterious_cartouche_reveal_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 83120, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 82308, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 84700, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 79268, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77076, 81),
      ))
    }

@delegate:ResourceContentHash(-1_484_115_365)
internal val Res.string.exp_content_mysterious_cartouche_target: StringResource by lazy {
      StringResource("string:exp_content_mysterious_cartouche_target", "exp_content_mysterious_cartouche_target", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 83202, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 82398, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 84786, 171),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 79350, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77158, 147),
      ))
    }

@delegate:ResourceContentHash(999_252_871)
internal val Res.string.exp_content_nel_nostro_prossimo_viaggio_scopriremo_come_c: StringResource by
    lazy {
      StringResource("string:exp_content_nel_nostro_prossimo_viaggio_scopriremo_come_c", "exp_content_nel_nostro_prossimo_viaggio_scopriremo_come_c", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 83354, 185),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 82558, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 84958, 173),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 79510, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77306, 165),
      ))
    }

@delegate:ResourceContentHash(-2_092_488_555)
internal val Res.string.exp_content_nel_quiz_traduci_frasi_con_l_apposizione_mantenendo:
    StringResource by lazy {
      StringResource("string:exp_content_nel_quiz_traduci_frasi_con_l_apposizione_mantenendo", "exp_content_nel_quiz_traduci_frasi_con_l_apposizione_mantenendo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 83540, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 82736, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 85132, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 79680, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77472, 135),
      ))
    }

@delegate:ResourceContentHash(2_070_239_774)
internal val Res.string.exp_content_nell_apposizione_due_nomi_vicini_indicano_la_stessa:
    StringResource by lazy {
      StringResource("string:exp_content_nell_apposizione_due_nomi_vicini_indicano_la_stessa", "exp_content_nell_apposizione_due_nomi_vicini_indicano_la_stessa", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 83672, 251),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 82856, 267),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 85276, 247),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 79796, 259),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77608, 235),
      ))
    }

@delegate:ResourceContentHash(-47_309_234)
internal val Res.string.exp_content_nell_esempio_l_ultimo_simbolo_ra_guarda_verso: StringResource by
    lazy {
      StringResource("string:exp_content_nell_esempio_l_ultimo_simbolo_ra_guarda_verso", "exp_content_nell_esempio_l_ultimo_simbolo_ra_guarda_verso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 83924, 209),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 83124, 221),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 85524, 209),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 80056, 205),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77844, 181),
      ))
    }

@delegate:ResourceContentHash(-310_856_516)
internal val Res.string.exp_content_nell_intero_quadrato: StringResource by lazy {
      StringResource("string:exp_content_nell_intero_quadrato", "exp_content_nell_intero_quadrato", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 84134, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 83346, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 85734, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 80262, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78026, 68),
      ))
    }

@delegate:ResourceContentHash(-1_516_968_491)
internal val Res.string.exp_content_nella_lezione_scorsa_abbiamo_visto_la_forma_pi_semplice:
    StringResource by lazy {
      StringResource("string:exp_content_nella_lezione_scorsa_abbiamo_visto_la_forma_pi_semplice", "exp_content_nella_lezione_scorsa_abbiamo_visto_la_forma_pi_semplice", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 84199, 191),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 83419, 171),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 85807, 195),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 80331, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78095, 175),
      ))
    }

@delegate:ResourceContentHash(-1_123_821_834)
internal val Res.string.exp_content_nella_parola_padre_it_il_segno_del_serpente_f: StringResource by
    lazy {
      StringResource("string:exp_content_nella_parola_padre_it_il_segno_del_serpente_f", "exp_content_nella_parola_padre_it_il_segno_del_serpente_f", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 84391, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 83591, 173),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 86003, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 80515, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78271, 157),
      ))
    }

@delegate:ResourceContentHash(-1_691_871_066)
internal val Res.string.exp_content_nella_parola_uomo_rmt_il_segno_monolittero_pe: StringResource by
    lazy {
      StringResource("string:exp_content_nella_parola_uomo_rmt_il_segno_monolittero_pe", "exp_content_nella_parola_uomo_rmt_il_segno_monolittero_pe", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 84545, 225),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 83765, 229),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 86169, 233),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 80693, 237),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78429, 205),
      ))
    }

@delegate:ResourceContentHash(520_394_930)
internal val Res.string.exp_content_nelle_lezioni_precedenti_abbiamo_visto_il_gen: StringResource by
    lazy {
      StringResource("string:exp_content_nelle_lezioni_precedenti_abbiamo_visto_il_gen", "exp_content_nelle_lezioni_precedenti_abbiamo_visto_il_gen", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 84771, 297),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 83995, 269),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 86403, 285),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 80931, 261),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78635, 257),
      ))
    }

@delegate:ResourceContentHash(525_903_476)
internal val Res.string.exp_content_nelle_nostre_lezioni_cercheremo_di_usare_solo: StringResource by
    lazy {
      StringResource("string:exp_content_nelle_nostre_lezioni_cercheremo_di_usare_solo", "exp_content_nelle_nostre_lezioni_cercheremo_di_usare_solo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85069, 189),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 84265, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 86689, 185),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 81193, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78893, 153),
      ))
    }

@delegate:ResourceContentHash(158_633_042)
internal val Res.string.exp_content_nilo_ci_rimasto_di_sasso: StringResource by lazy {
      StringResource("string:exp_content_nilo_ci_rimasto_di_sasso", "exp_content_nilo_ci_rimasto_di_sasso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 85259, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 84431, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 86875, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 81359, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79047, 68),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString7Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_la_particella_ni_14", Res.string.exp_content_la_particella_ni_14)
  map.put("exp_content_la_particella_ni_2", Res.string.exp_content_la_particella_ni_2)
  map.put("exp_content_la_particella_ni_3", Res.string.exp_content_la_particella_ni_3)
  map.put("exp_content_la_particella_ni_4", Res.string.exp_content_la_particella_ni_4)
  map.put("exp_content_la_particella_ni_5", Res.string.exp_content_la_particella_ni_5)
  map.put("exp_content_la_particella_ni_6", Res.string.exp_content_la_particella_ni_6)
  map.put("exp_content_la_particella_ni_7", Res.string.exp_content_la_particella_ni_7)
  map.put("exp_content_la_particella_ni_8", Res.string.exp_content_la_particella_ni_8)
  map.put("exp_content_la_particella_ni_9", Res.string.exp_content_la_particella_ni_9)
  map.put("exp_content_la_pazienza_e_finita_1", Res.string.exp_content_la_pazienza_e_finita_1)
  map.put("exp_content_la_pazienza_e_finita_2", Res.string.exp_content_la_pazienza_e_finita_2)
  map.put("exp_content_la_pazienza_e_finita_3", Res.string.exp_content_la_pazienza_e_finita_3)
  map.put("exp_content_la_pazienza_e_finita_4", Res.string.exp_content_la_pazienza_e_finita_4)
  map.put("exp_content_la_pazienza_e_finita_5", Res.string.exp_content_la_pazienza_e_finita_5)
  map.put("exp_content_la_pazienza_e_finita_6", Res.string.exp_content_la_pazienza_e_finita_6)
  map.put("exp_content_la_pazienza_e_finita_7", Res.string.exp_content_la_pazienza_e_finita_7)
  map.put("exp_content_la_pazienza_e_finita_8", Res.string.exp_content_la_pazienza_e_finita_8)
  map.put("exp_content_la_struttura_semplice_n_n_nome_1_nome_2_nome_", Res.string.exp_content_la_struttura_semplice_n_n_nome_1_nome_2_nome_)
  map.put("exp_content_la_struttura_semplicissima_n_n_nome_posseduto", Res.string.exp_content_la_struttura_semplicissima_n_n_nome_posseduto)
  map.put("exp_content_la_teoria_1", Res.string.exp_content_la_teoria_1)
  map.put("exp_content_la_teoria_2", Res.string.exp_content_la_teoria_2)
  map.put("exp_content_la_teoria_3", Res.string.exp_content_la_teoria_3)
  map.put("exp_content_la_teoria_4", Res.string.exp_content_la_teoria_4)
  map.put("exp_content_la_teoria_5", Res.string.exp_content_la_teoria_5)
  map.put("exp_content_la_teoria_6", Res.string.exp_content_la_teoria_6)
  map.put("exp_content_la_teoria_7", Res.string.exp_content_la_teoria_7)
  map.put("exp_content_le_due_sorelle_snty", Res.string.exp_content_le_due_sorelle_snty)
  map.put("exp_content_le_frasi_avverbiali_1", Res.string.exp_content_le_frasi_avverbiali_1)
  map.put("exp_content_le_frasi_avverbiali_2", Res.string.exp_content_le_frasi_avverbiali_2)
  map.put("exp_content_le_frasi_avverbiali_3", Res.string.exp_content_le_frasi_avverbiali_3)
  map.put("exp_content_le_frasi_avverbiali_4", Res.string.exp_content_le_frasi_avverbiali_4)
  map.put("exp_content_le_frasi_avverbiali_5", Res.string.exp_content_le_frasi_avverbiali_5)
  map.put("exp_content_le_preposizioni_1", Res.string.exp_content_le_preposizioni_1)
  map.put("exp_content_le_preposizioni_10", Res.string.exp_content_le_preposizioni_10)
  map.put("exp_content_le_preposizioni_11", Res.string.exp_content_le_preposizioni_11)
  map.put("exp_content_le_preposizioni_12", Res.string.exp_content_le_preposizioni_12)
  map.put("exp_content_le_preposizioni_13", Res.string.exp_content_le_preposizioni_13)
  map.put("exp_content_le_preposizioni_14", Res.string.exp_content_le_preposizioni_14)
  map.put("exp_content_le_preposizioni_15", Res.string.exp_content_le_preposizioni_15)
  map.put("exp_content_le_preposizioni_16", Res.string.exp_content_le_preposizioni_16)
  map.put("exp_content_le_preposizioni_17", Res.string.exp_content_le_preposizioni_17)
  map.put("exp_content_le_preposizioni_18", Res.string.exp_content_le_preposizioni_18)
  map.put("exp_content_le_preposizioni_19", Res.string.exp_content_le_preposizioni_19)
  map.put("exp_content_le_preposizioni_2", Res.string.exp_content_le_preposizioni_2)
  map.put("exp_content_le_preposizioni_20", Res.string.exp_content_le_preposizioni_20)
  map.put("exp_content_le_preposizioni_21", Res.string.exp_content_le_preposizioni_21)
  map.put("exp_content_le_preposizioni_22", Res.string.exp_content_le_preposizioni_22)
  map.put("exp_content_le_preposizioni_23", Res.string.exp_content_le_preposizioni_23)
  map.put("exp_content_le_preposizioni_3", Res.string.exp_content_le_preposizioni_3)
  map.put("exp_content_le_preposizioni_4", Res.string.exp_content_le_preposizioni_4)
  map.put("exp_content_le_preposizioni_5", Res.string.exp_content_le_preposizioni_5)
  map.put("exp_content_le_preposizioni_6", Res.string.exp_content_le_preposizioni_6)
  map.put("exp_content_le_preposizioni_7", Res.string.exp_content_le_preposizioni_7)
  map.put("exp_content_le_preposizioni_8", Res.string.exp_content_le_preposizioni_8)
  map.put("exp_content_le_preposizioni_9", Res.string.exp_content_le_preposizioni_9)
  map.put("exp_content_lezione_finita", Res.string.exp_content_lezione_finita)
  map.put("exp_content_lezione_finita_cartigli", Res.string.exp_content_lezione_finita_cartigli)
  map.put("exp_content_lezione_finita_genitivo_indiretto_i", Res.string.exp_content_lezione_finita_genitivo_indiretto_i)
  map.put("exp_content_ma_come_faccio_a_capire_se_due_nomi_in_fila_s", Res.string.exp_content_ma_come_faccio_a_capire_se_due_nomi_in_fila_s)
  map.put("exp_content_ma_cosa_succede_se_accostiamo_vino_e_birra_n_", Res.string.exp_content_ma_cosa_succede_se_accostiamo_vino_e_birra_n_)
  map.put("exp_content_ma_prima", Res.string.exp_content_ma_prima)
  map.put("exp_content_ma_prima_di_procedere_mettiti_alla_prova_con_", Res.string.exp_content_ma_prima_di_procedere_mettiti_alla_prova_con_)
  map.put("exp_content_ma_se_una_scritta_composta_solo_da_segni_simm", Res.string.exp_content_ma_se_una_scritta_composta_solo_da_segni_simm)
  map.put("exp_content_mi_ti_srw_1", Res.string.exp_content_mi_ti_srw_1)
  map.put("exp_content_mi_ti_srw_10", Res.string.exp_content_mi_ti_srw_10)
  map.put("exp_content_mi_ti_srw_11", Res.string.exp_content_mi_ti_srw_11)
  map.put("exp_content_mi_ti_srw_12", Res.string.exp_content_mi_ti_srw_12)
  map.put("exp_content_mi_ti_srw_13", Res.string.exp_content_mi_ti_srw_13)
  map.put("exp_content_mi_ti_srw_14", Res.string.exp_content_mi_ti_srw_14)
  map.put("exp_content_mi_ti_srw_2", Res.string.exp_content_mi_ti_srw_2)
  map.put("exp_content_mi_ti_srw_3", Res.string.exp_content_mi_ti_srw_3)
  map.put("exp_content_mi_ti_srw_4", Res.string.exp_content_mi_ti_srw_4)
  map.put("exp_content_mi_ti_srw_5", Res.string.exp_content_mi_ti_srw_5)
  map.put("exp_content_mi_ti_srw_6", Res.string.exp_content_mi_ti_srw_6)
  map.put("exp_content_mi_ti_srw_7", Res.string.exp_content_mi_ti_srw_7)
  map.put("exp_content_mi_ti_srw_8", Res.string.exp_content_mi_ti_srw_8)
  map.put("exp_content_mi_ti_srw_9", Res.string.exp_content_mi_ti_srw_9)
  map.put("exp_content_miao", Res.string.exp_content_miao)
  map.put("exp_content_mysterious_cartouche_intro", Res.string.exp_content_mysterious_cartouche_intro)
  map.put("exp_content_mysterious_cartouche_known_title", Res.string.exp_content_mysterious_cartouche_known_title)
  map.put("exp_content_mysterious_cartouche_known_words", Res.string.exp_content_mysterious_cartouche_known_words)
  map.put("exp_content_mysterious_cartouche_missing_word", Res.string.exp_content_mysterious_cartouche_missing_word)
  map.put("exp_content_mysterious_cartouche_reveal_1", Res.string.exp_content_mysterious_cartouche_reveal_1)
  map.put("exp_content_mysterious_cartouche_reveal_2", Res.string.exp_content_mysterious_cartouche_reveal_2)
  map.put("exp_content_mysterious_cartouche_reveal_3", Res.string.exp_content_mysterious_cartouche_reveal_3)
  map.put("exp_content_mysterious_cartouche_reveal_4", Res.string.exp_content_mysterious_cartouche_reveal_4)
  map.put("exp_content_mysterious_cartouche_reveal_5", Res.string.exp_content_mysterious_cartouche_reveal_5)
  map.put("exp_content_mysterious_cartouche_reveal_6", Res.string.exp_content_mysterious_cartouche_reveal_6)
  map.put("exp_content_mysterious_cartouche_target", Res.string.exp_content_mysterious_cartouche_target)
  map.put("exp_content_nel_nostro_prossimo_viaggio_scopriremo_come_c", Res.string.exp_content_nel_nostro_prossimo_viaggio_scopriremo_come_c)
  map.put("exp_content_nel_quiz_traduci_frasi_con_l_apposizione_mantenendo", Res.string.exp_content_nel_quiz_traduci_frasi_con_l_apposizione_mantenendo)
  map.put("exp_content_nell_apposizione_due_nomi_vicini_indicano_la_stessa", Res.string.exp_content_nell_apposizione_due_nomi_vicini_indicano_la_stessa)
  map.put("exp_content_nell_esempio_l_ultimo_simbolo_ra_guarda_verso", Res.string.exp_content_nell_esempio_l_ultimo_simbolo_ra_guarda_verso)
  map.put("exp_content_nell_intero_quadrato", Res.string.exp_content_nell_intero_quadrato)
  map.put("exp_content_nella_lezione_scorsa_abbiamo_visto_la_forma_pi_semplice", Res.string.exp_content_nella_lezione_scorsa_abbiamo_visto_la_forma_pi_semplice)
  map.put("exp_content_nella_parola_padre_it_il_segno_del_serpente_f", Res.string.exp_content_nella_parola_padre_it_il_segno_del_serpente_f)
  map.put("exp_content_nella_parola_uomo_rmt_il_segno_monolittero_pe", Res.string.exp_content_nella_parola_uomo_rmt_il_segno_monolittero_pe)
  map.put("exp_content_nelle_lezioni_precedenti_abbiamo_visto_il_gen", Res.string.exp_content_nelle_lezioni_precedenti_abbiamo_visto_il_gen)
  map.put("exp_content_nelle_nostre_lezioni_cercheremo_di_usare_solo", Res.string.exp_content_nelle_nostre_lezioni_cercheremo_di_usare_solo)
  map.put("exp_content_nilo_ci_rimasto_di_sasso", Res.string.exp_content_nilo_ci_rimasto_di_sasso)
}
